(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-js-legacy', 'kotlin-multiplatform-diff-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-js-legacy'), require('kotlin-multiplatform-diff-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-state-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-state-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-state-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-state-js-legacy'.");
    }if (typeof this['kotlin-multiplatform-diff-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-state-js-legacy'. Its dependency 'kotlin-multiplatform-diff-js-legacy' was not found. Please, check whether 'kotlin-multiplatform-diff-js-legacy' is loaded prior to 'kvision-kvision-state-js-legacy'.");
    }root['kvision-kvision-state-js-legacy'] = factory(typeof this['kvision-kvision-state-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-state-js-legacy'], kotlin, this['kvision-js-legacy'], this['kotlin-multiplatform-diff-js-legacy']);
  }
}(this, function (_, Kotlin, $module$kvision_js_legacy, $module$kotlin_multiplatform_diff_js_legacy) {
  'use strict';
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var MutableList = Kotlin.kotlin.collections.MutableList;
  var ObservableState = $module$kvision_js_legacy.io.kvision.state.ObservableState;
  var Unit = Kotlin.kotlin.Unit;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var MutableIterator = Kotlin.kotlin.collections.MutableIterator;
  var MutableListIterator = Kotlin.kotlin.collections.MutableListIterator;
  var toMutableList = Kotlin.kotlin.collections.toMutableList_us0mfu$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var MutableSet = Kotlin.kotlin.collections.MutableSet;
  var toMutableSet = Kotlin.kotlin.collections.toMutableSet_us0mfu$;
  var LinkedHashSet_init = Kotlin.kotlin.collections.LinkedHashSet_init_287e2$;
  var ObservableValue = $module$kvision_js_legacy.io.kvision.state.ObservableValue;
  var equals = Kotlin.equals;
  var Container = $module$kvision_js_legacy.io.kvision.core.Container;
  var Display = $module$kvision_js_legacy.io.kvision.core.Display;
  var simplePanel = $module$kvision_js_legacy.io.kvision.panel.simplePanel_jhiteo$;
  var ensureNotNull = Kotlin.ensureNotNull;
  var SimplePanel = $module$kvision_js_legacy.io.kvision.panel.SimplePanel;
  var first = Kotlin.kotlin.collections.first_2p1efm$;
  var emptyList = Kotlin.kotlin.collections.emptyList_287e2$;
  var toList = Kotlin.kotlin.collections.toList_7wnvza$;
  var numberToInt = Kotlin.numberToInt;
  var numberToDouble = Kotlin.numberToDouble;
  var checkIndexOverflow = Kotlin.kotlin.collections.checkIndexOverflow_za3lpa$;
  function ObservableList() {
  }
  ObservableList.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'ObservableList', interfaces: [ObservableState, MutableList]};
  function ObservableListWrapper(mutableList) {
    if (mutableList === void 0) {
      mutableList = ArrayList_init();
    }this.mutableList = mutableList;
    this.onUpdate_hipm4q$_0 = ArrayList_init();
  }
  ObservableListWrapper.prototype.getState = function () {
    return this;
  };
  function ObservableListWrapper$subscribe$lambda(this$ObservableListWrapper, closure$observer) {
    return function () {
      var $receiver = this$ObservableListWrapper.onUpdate;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  ObservableListWrapper.prototype.subscribe_qlkmfe$ = function (observer) {
    this.onUpdate.add_11rb$(observer);
    observer(this);
    return ObservableListWrapper$subscribe$lambda(this, observer);
  };
  Object.defineProperty(ObservableListWrapper.prototype, 'onUpdate', {configurable: true, get: function () {
    return this.onUpdate_hipm4q$_0;
  }});
  Object.defineProperty(ObservableListWrapper.prototype, 'size', {configurable: true, get: function () {
    return this.mutableList.size;
  }});
  ObservableListWrapper.prototype.contains_11rb$ = function (element) {
    return this.mutableList.contains_11rb$(element);
  };
  ObservableListWrapper.prototype.containsAll_brywnq$ = function (elements) {
    return this.mutableList.containsAll_brywnq$(elements);
  };
  ObservableListWrapper.prototype.get_za3lpa$ = function (index) {
    return this.mutableList.get_za3lpa$(index);
  };
  ObservableListWrapper.prototype.indexOf_11rb$ = function (element) {
    return this.mutableList.indexOf_11rb$(element);
  };
  ObservableListWrapper.prototype.isEmpty = function () {
    return this.mutableList.isEmpty();
  };
  function ObservableListWrapper$iterator$ObjectLiteral(this$ObservableListWrapper) {
    this.this$ObservableListWrapper = this$ObservableListWrapper;
    this.inner = this$ObservableListWrapper.mutableList.iterator();
  }
  ObservableListWrapper$iterator$ObjectLiteral.prototype.hasNext = function () {
    return this.inner.hasNext();
  };
  ObservableListWrapper$iterator$ObjectLiteral.prototype.next = function () {
    return this.inner.next();
  };
  ObservableListWrapper$iterator$ObjectLiteral.prototype.remove = function () {
    this.inner.remove();
    var $receiver = this.this$ObservableListWrapper.onUpdate;
    this.this$ObservableListWrapper;
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element(this.this$ObservableListWrapper);
    }
  };
  ObservableListWrapper$iterator$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [MutableIterator]};
  ObservableListWrapper.prototype.iterator = function () {
    return new ObservableListWrapper$iterator$ObjectLiteral(this);
  };
  ObservableListWrapper.prototype.lastIndexOf_11rb$ = function (element) {
    return this.mutableList.lastIndexOf_11rb$(element);
  };
  function ObservableListWrapper$listIterator$ObjectLiteral(this$ObservableListWrapper) {
    this.this$ObservableListWrapper = this$ObservableListWrapper;
    this.inner = this$ObservableListWrapper.mutableList.listIterator();
  }
  ObservableListWrapper$listIterator$ObjectLiteral.prototype.hasNext = function () {
    return this.inner.hasNext();
  };
  ObservableListWrapper$listIterator$ObjectLiteral.prototype.next = function () {
    return this.inner.next();
  };
  ObservableListWrapper$listIterator$ObjectLiteral.prototype.hasPrevious = function () {
    return this.inner.hasPrevious();
  };
  ObservableListWrapper$listIterator$ObjectLiteral.prototype.nextIndex = function () {
    return this.inner.nextIndex();
  };
  ObservableListWrapper$listIterator$ObjectLiteral.prototype.previous = function () {
    return this.inner.previous();
  };
  ObservableListWrapper$listIterator$ObjectLiteral.prototype.previousIndex = function () {
    return this.inner.previousIndex();
  };
  ObservableListWrapper$listIterator$ObjectLiteral.prototype.add_11rb$ = function (element) {
    this.inner.add_11rb$(element);
    var $receiver = this.this$ObservableListWrapper.onUpdate;
    this.this$ObservableListWrapper;
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element_0 = tmp$.next();
      element_0(this.this$ObservableListWrapper);
    }
  };
  ObservableListWrapper$listIterator$ObjectLiteral.prototype.set_11rb$ = function (element) {
    this.inner.set_11rb$(element);
    var $receiver = this.this$ObservableListWrapper.onUpdate;
    this.this$ObservableListWrapper;
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element_0 = tmp$.next();
      element_0(this.this$ObservableListWrapper);
    }
  };
  ObservableListWrapper$listIterator$ObjectLiteral.prototype.remove = function () {
    this.inner.remove();
    var $receiver = this.this$ObservableListWrapper.onUpdate;
    this.this$ObservableListWrapper;
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element(this.this$ObservableListWrapper);
    }
  };
  ObservableListWrapper$listIterator$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [MutableListIterator]};
  ObservableListWrapper.prototype.listIterator = function () {
    return new ObservableListWrapper$listIterator$ObjectLiteral(this);
  };
  function ObservableListWrapper$listIterator$ObjectLiteral_0(this$ObservableListWrapper, closure$index) {
    this.this$ObservableListWrapper = this$ObservableListWrapper;
    this.inner = this$ObservableListWrapper.mutableList.listIterator_za3lpa$(closure$index);
  }
  ObservableListWrapper$listIterator$ObjectLiteral_0.prototype.hasNext = function () {
    return this.inner.hasNext();
  };
  ObservableListWrapper$listIterator$ObjectLiteral_0.prototype.next = function () {
    return this.inner.next();
  };
  ObservableListWrapper$listIterator$ObjectLiteral_0.prototype.hasPrevious = function () {
    return this.inner.hasPrevious();
  };
  ObservableListWrapper$listIterator$ObjectLiteral_0.prototype.nextIndex = function () {
    return this.inner.nextIndex();
  };
  ObservableListWrapper$listIterator$ObjectLiteral_0.prototype.previous = function () {
    return this.inner.previous();
  };
  ObservableListWrapper$listIterator$ObjectLiteral_0.prototype.previousIndex = function () {
    return this.inner.previousIndex();
  };
  ObservableListWrapper$listIterator$ObjectLiteral_0.prototype.add_11rb$ = function (element) {
    this.inner.add_11rb$(element);
    var $receiver = this.this$ObservableListWrapper.onUpdate;
    this.this$ObservableListWrapper;
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element_0 = tmp$.next();
      element_0(this.this$ObservableListWrapper);
    }
  };
  ObservableListWrapper$listIterator$ObjectLiteral_0.prototype.set_11rb$ = function (element) {
    this.inner.set_11rb$(element);
    var $receiver = this.this$ObservableListWrapper.onUpdate;
    this.this$ObservableListWrapper;
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element_0 = tmp$.next();
      element_0(this.this$ObservableListWrapper);
    }
  };
  ObservableListWrapper$listIterator$ObjectLiteral_0.prototype.remove = function () {
    this.inner.remove();
    var $receiver = this.this$ObservableListWrapper.onUpdate;
    this.this$ObservableListWrapper;
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element(this.this$ObservableListWrapper);
    }
  };
  ObservableListWrapper$listIterator$ObjectLiteral_0.$metadata$ = {kind: Kind_CLASS, interfaces: [MutableListIterator]};
  ObservableListWrapper.prototype.listIterator_za3lpa$ = function (index) {
    return new ObservableListWrapper$listIterator$ObjectLiteral_0(this, index);
  };
  ObservableListWrapper.prototype.subList_vux9f0$ = function (fromIndex, toIndex) {
    return this.mutableList.subList_vux9f0$(fromIndex, toIndex);
  };
  ObservableListWrapper.prototype.add_11rb$ = function (element) {
    var result = this.mutableList.add_11rb$(element);
    if (result) {
      var tmp$;
      tmp$ = this.onUpdate.iterator();
      while (tmp$.hasNext()) {
        var element_0 = tmp$.next();
        element_0(this);
      }
    }return result;
  };
  ObservableListWrapper.prototype.add_wxm5ur$ = function (index, element) {
    this.mutableList.add_wxm5ur$(index, element);
    var tmp$;
    tmp$ = this.onUpdate.iterator();
    while (tmp$.hasNext()) {
      var element_0 = tmp$.next();
      element_0(this);
    }
  };
  ObservableListWrapper.prototype.addAll_brywnq$ = function (elements) {
    var result = this.mutableList.addAll_brywnq$(elements);
    if (result) {
      var tmp$;
      tmp$ = this.onUpdate.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(this);
      }
    }return result;
  };
  ObservableListWrapper.prototype.addAll_u57x28$ = function (index, elements) {
    var result = this.mutableList.addAll_u57x28$(index, elements);
    if (result) {
      var tmp$;
      tmp$ = this.onUpdate.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(this);
      }
    }return result;
  };
  ObservableListWrapper.prototype.clear = function () {
    this.mutableList.clear();
    var tmp$;
    tmp$ = this.onUpdate.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element(this);
    }
  };
  ObservableListWrapper.prototype.remove_11rb$ = function (element) {
    var result = this.mutableList.remove_11rb$(element);
    if (result) {
      var tmp$;
      tmp$ = this.onUpdate.iterator();
      while (tmp$.hasNext()) {
        var element_0 = tmp$.next();
        element_0(this);
      }
    }return result;
  };
  ObservableListWrapper.prototype.removeAt_za3lpa$ = function (index) {
    var result = this.mutableList.removeAt_za3lpa$(index);
    var tmp$;
    tmp$ = this.onUpdate.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element(this);
    }
    return result;
  };
  ObservableListWrapper.prototype.removeAll_brywnq$ = function (elements) {
    var result = this.mutableList.removeAll_brywnq$(elements);
    if (result) {
      var tmp$;
      tmp$ = this.onUpdate.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(this);
      }
    }return result;
  };
  ObservableListWrapper.prototype.retainAll_brywnq$ = function (elements) {
    var result = this.mutableList.retainAll_brywnq$(elements);
    if (result) {
      var tmp$;
      tmp$ = this.onUpdate.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(this);
      }
    }return result;
  };
  ObservableListWrapper.prototype.set_wxm5ur$ = function (index, element) {
    var result = this.mutableList.set_wxm5ur$(index, element);
    var tmp$;
    tmp$ = this.onUpdate.iterator();
    while (tmp$.hasNext()) {
      var element_0 = tmp$.next();
      element_0(this);
    }
    return result;
  };
  ObservableListWrapper.$metadata$ = {kind: Kind_CLASS, simpleName: 'ObservableListWrapper', interfaces: [ObservableList, ObservableState, MutableList]};
  function observableListOf(items) {
    return new ObservableListWrapper(toMutableList(items));
  }
  function sub$lambda(closure$extractor, closure$observableValue) {
    return function (s) {
      var newValue = closure$extractor(s);
      if (!equals(closure$observableValue.value, newValue)) {
        closure$observableValue.value = newValue;
      }return Unit;
    };
  }
  function sub$lambda$lambda(closure$unsubscribe) {
    return function () {
      closure$unsubscribe();
      return Unit;
    };
  }
  function sub($receiver, contextWidget, extractor) {
    if (contextWidget === void 0)
      contextWidget = null;
    var observableValue = new ObservableValue(extractor($receiver.getState()));
    var unsubscribe = $receiver.subscribe_qlkmfe$(sub$lambda(extractor, observableValue));
    if (contextWidget != null) {
      contextWidget.addBeforeDisposeHook_o14v8n$(sub$lambda$lambda(unsubscribe));
    }return observableValue;
  }
  function bind$lambda$lambda(closure$removeChildren, this$bind, closure$factory, closure$it) {
    return function () {
      var tmp$, tmp$_0;
      if (closure$removeChildren)
        (tmp$_0 = Kotlin.isType(tmp$ = this$bind, Container) ? tmp$ : null) != null ? tmp$_0.disposeAll() : null;
      closure$factory(this$bind, closure$it);
      return Unit;
    };
  }
  function bind$lambda(closure$skip, this$bind, closure$removeChildren, closure$factory) {
    return function (it) {
      if (!closure$skip.v) {
        this$bind.singleRenderAsync_o14v8n$(bind$lambda$lambda(closure$removeChildren, this$bind, closure$factory, it));
      } else {
        closure$skip.v = false;
      }
      return Unit;
    };
  }
  function bind($receiver, observableState, removeChildren, runImmediately, factory) {
    if (removeChildren === void 0)
      removeChildren = true;
    if (runImmediately === void 0)
      runImmediately = true;
    var skip = {v: !runImmediately};
    $receiver.addBeforeDisposeHook_o14v8n$(observableState.subscribe_qlkmfe$(bind$lambda(skip, $receiver, removeChildren, factory)));
    return $receiver;
  }
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  var package$state = package$kvision.state || (package$kvision.state = {});
  package$state.ObservableList = ObservableList;
  package$state.ObservableListWrapper = ObservableListWrapper;
  package$state.observableListOf_i5x0yv$ = observableListOf;
  package$state.sub_9lzg7y$ = sub;
  package$state.bind_rcwtew$ = bind;
  return _;
}));

//# sourceMappingURL=kvision-kvision-state-js-legacy.js.map
